module.exports = "Soon..."


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/changelog/changelog.component.html
// module id = ../../../../../src/app/projects/shared/changelog/changelog.component.html
// module chunks = main